export default __webpack_public_path__ + "static/media/youngestBillionare.710cdb8c.jpg";